
    /** Generated by webpack-jst-loader */
    (function() {
      window.JST || (window.JST = {});
      window.JST["app_base/components/loader_v2/templates/layout"] = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class='loaderComponent-loadableText'>"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"loadable_text") || (depth0 != null ? lookupProperty(depth0,"loadable_text") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"loadable_text","hash":{},"data":data,"loc":{"start":{"line":1,"column":42},"end":{"line":1,"column":61}}}) : helper)))
    + "</div>\n<div class='loaderComponent-animationRegion'></div>\n";
},"useData":true});
    }).call(this);
  